import React from "react";
import EditSubscriptionForm from "./components/EditSubscriptionForm";

const EditSubscriptionFormContainer=()=><EditSubscriptionForm/>;

export default EditSubscriptionFormContainer;